import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { DragAndDropService } from './drag-and-drop.service';

import { DraggableDirective } from './draggable.directive';
import { DropZoneDirective } from './drop-zone.directive';

export { DragAndDropEvent } from './drag-and-drop.service';
export { DraggableDirective } from './draggable.directive';
export { DropZoneDirective } from './drop-zone.directive';

@NgModule({
  declarations: [
    DraggableDirective,
    DropZoneDirective
  ],
  exports: [
    DraggableDirective,
    DropZoneDirective
  ],
  providers: [
    DragAndDropService
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class DragAndDropModule {}
